import { nanoid } from 'nanoid'
import formatterDate from './fmt/date'
import formatterNumber from './fmt/number'

export const fmt = {
  ...formatterDate,
  ...formatterNumber,
}

export const randomId = nanoid
